import { NotificationsNotificationsSessionDto } from '@mi-front/api-v2';
import { createContext } from 'react';

export type NotificationsSessionContextValue = {
  /** Active provider from the session API, or null while loading / on error. */
  provider: NotificationsNotificationsSessionDto['provider'] | null;
  /** True when KnockProvider + feed channel are ready for feed/prefs. */
  isKnockReady: boolean;
  session: NotificationsNotificationsSessionDto | null;
  isLoading: boolean;
  refetchSession: () => Promise<NotificationsNotificationsSessionDto | undefined>;
};

export const NotificationsSessionContext = createContext<NotificationsSessionContextValue | null>(
  null,
);

export const NotificationsSessionContextProvider = NotificationsSessionContext.Provider;
